import Vue from "vue";
import axios from "axios";
import router from "../router";

export const baseURL = `${window.location.origin}/api`;
Vue.prototype.$baseURL = baseURL;

let contentType = "application/json; charset=utf-8";

axios.defaults.baseURL = baseURL;
axios.defaults.headers["Content-Type"] = contentType;
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

axios.interceptors.request.use(
  (config) => {
    let filters = [`/auth/oauth/token`];
    if (!filters.includes(config.url)) {
      let token = localStorage.auth_token;
      if (token) config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

function loadBlobText(data) {
  return new Promise(function(resolve, reject) {
    let content;
    let reader = new FileReader();
    reader.onload = function(event) {
      content = reader.result;
      resolve(content);
    };
    reader.readAsText(data);
  });
}

axios.interceptors.response.use(
  (res) => {
    if (res.status === 204) {
      res.data = "SUCCESS";
    }
    return res;
  },
  async (error) => {
    const { response: res } = error;
    let msg;
    if (res.data instanceof Blob) {
      msg = JSON.parse(await loadBlobText(res.data)).message;
    } else {
      msg = res && res.data ? res.data.message : "请重新登录";
    }
    if (!res) res.status = 401;
    switch (res.status) {
      case 401:
        msg = "登录超时，请重新登录";
        Vue.prototype.$logout();
        break;
      case 404:
      case 405:
        if (!msg) msg = "访问有误";
        break;
      case 500:
      case 502:
      case 504:
        if (!msg) msg = "连接超时";
        break;
    }
    return Promise.reject(msg);
  }
);

export const fetch = (url, method, config = {}) => {
  return axios({ url, method, ...config }).catch((message) => {
    if (!message || typeof message !== "string") message = "访问有误";
    Vue.prototype.$message.closeAll();
    Vue.prototype.$message({
      message,
      type: "error",
    });
    return false;
  });
};

export const postFile = (url, data, config) =>
  axios.post(url, data, config).then((res) => res.data);
